import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useIntl } from "react-intl";
import { Link, Navigate, useParams } from "react-router-dom";
import ClaimSelector from "./ClaimSelector";
import { useStrictQuery } from "hooks/useStrictQuery";

const RoleDetails = () => {
  const { id } = useParams<{ id: string }>();
  const { rolesUrl, roleEditUrl, roleService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { isLoading, data } = useStrictQuery(
    ["role", id],
    () => roleService.getRole(id!),
    {
      enabled: !!id,
    }
  );

  const role = data?.data;
  useTitle(role?.name || "Role Details");

  if (!id) return <Navigate to={rolesUrl()} replace />;
  if (isLoading) return <Loader />;

  const rows = [
    {
      title: t({ id: "nameLabel" }),
      component: <span>{role?.name}</span>,
    },
    {
      title: t({ id: "descriptionLabel" }),
      component: role?.description && <span>{role.description}</span>,
    },
  ].filter((r) => r.component);

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={rolesUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h4">{role?.name}</Typography>

      <Box my={3} display="flex" justifyContent="center">
        <Link to={roleEditUrl(id)} style={{ textDecoration: "none" }}>
          <Fab color="primary">
            <EditIcon />
          </Fab>
        </Link>
      </Box>

      <Box my={3}>
        <TableContainer>
          <Table>
            <TableBody>
              {rows.map(({ title, component }, i) => (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    <b>{title}</b>
                  </TableCell>
                  <TableCell>{component}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ClaimSelector disabled selectedIds={role?.claimIds ?? []} />
      </Box>
    </>
  );
};

export default RoleDetails;
